import { backendAPI } from 'api';
import { call, put } from 'redux-saga/effects';
import {
  updateAutoScalingSettingSuccess,
  updateAutoScalingSettingFailed,
} from '../actions';

export default function* handleUpdateAutoScaling({ payload }) {
  try {
    const data = yield call(
      backendAPI.updateAutoScalingSetting,
      payload.id,
      payload.data,
    );

    yield put(updateAutoScalingSettingSuccess(data));
  } catch (e) {
    yield put(updateAutoScalingSettingFailed(e));
  }
}
